import React, { FunctionComponent } from 'react';
import { ResponseHandlerProvider, TranslationProvider } from '../services';

const WithGlobalServices = (WrappedComponent: FunctionComponent<any>) => {
	const showTime = 3600; // show time = 1s
	return (props: any) => (
		<ResponseHandlerProvider showTime={showTime}>
			<TranslationProvider>
				<WrappedComponent {...props} />
			</TranslationProvider>
		</ResponseHandlerProvider>
	);
};
export default WithGlobalServices;
